<template>
  <div>
    <v-row style="height: 82vh" class="d-flex flex-row mb-3 mt-0 mt-md-10">
      <v-col cols="12" class="d-flex flex-row my-0 py-0">
        <v-row>
          <v-col cols="10" sm="7" md="8">
            <v-card
              :min-width="$root.isDesktop ? null : '90%'"
              color="primary"
              tile
              class="diagonal-border register pl-2 mx-4 mt-0 pt-0"
            >
              <div class="normal-text ml-5 ml-md-10">
                <span
                  class="title-font-secondary white--text"
                  v-html="t('title')"
                >
                </span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" class="background-container">
            <v-container v-if="showBackground">
              <v-img
                class="background-position background-size"
                transition="scroll-x-transition"
                :src="background"
              ></v-img>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="7" class="mt-md-5">
        <v-row dense class="mb-2" v-for="(item, i) in t('steps')" :key="i">
          <v-col cols="2" sm="1" md="1" class="d-flex align-center">
            <v-img height="auto" max-width="28px" :src="iconArrow"></v-img>
          </v-col>
          <v-col>
            <span v-html="item"></span>
          </v-col>
        </v-row>
        <v-row dense class="mt-5" v-if="$root.isDesktop">
          <v-col cols="12"  class="d-flex justify-center justify-sm-start">
            <sc-btn  to="/signup" max-width="180px" width="100%">{{
              t("registration")
            }}</sc-btn>
          </v-col>
        </v-row>
        <v-row dense class="mt-10" v-else>
          <v-col cols="12" class="mb-2">
            <sc-btn block   to="/signup" width="100%">{{ t("registration") }}</sc-btn>
          </v-col>
          <v-col cols="12">
            <sc-btn @click="$root.toLogin" outlined block width="100%">{{ t("login") }}</sc-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    iconArrow: require("@/assets/icons/icon-arrow.png"),
    background: require("@/assets/images/banner_home.png"),
    showBackground: false,
  }),
  mounted() {
    setTimeout(() => (this.showBackground = true), 100);
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`public.landing.logistics.${key}`, options);
    },
  },
};
</script>
<style lang="scss" scoped>
.background-container {
  min-height: 0px;
}
.background-position {
  position: absolute;
  top: 13%;
  right: 10%;
  z-index: 0;
}
.background-size {
  width: 50%;
  height: auto;
}

.register {
  position: relative;
  z-index: 1;
}
.diagonal-border {
  transform: skewX(-15deg);
}
.diagonal-border .normal-text {
  display: block;
  transform: skew(15deg);
}

@media only screen and (max-width: 350px) and (min-width: 0px) {
  .background-position {
    top: 100px;
    left: 5%;
    right: 5%;
  }
  .background-size {
    width: 85%;
    height: auto;
  }
  .background-container {
    min-height: 100px;
  }
}
@media only screen and (max-width: 500px) and (min-width: 351px) {
  .background-position {
    top: 120px;
    left: 5%;
    right: 5%;
  }
  .background-size {
    width: 85%;
    height: auto;
  }
  .background-container {
    min-height: 180px;
  }
}
@media only screen and (max-width: 800px) and (min-width: 501px) {
  .background-position {
    top: 70px;
    right: 5%;
  }
  .background-size {
    width: 40%;
    height: auto;
  }
  .background-container {
    min-height: 0px;
  }
}
</style>
